/**
 * @generated SignedSource<<03ef3628b9a447c73834dc14579a9824>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type OrganizationTeachersXlsxCreateInput = {
  file: Upload;
  organization: string;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type MATOrganizationTeachersXlsxCreateDialog_organizationStudentsXlsxCreateMutation$variables = {
  input: OrganizationTeachersXlsxCreateInput;
};
export type MATOrganizationTeachersXlsxCreateDialog_organizationStudentsXlsxCreateMutation$data = {
  readonly organizationTeachersXlsxCreate: boolean;
};
export type MATOrganizationTeachersXlsxCreateDialog_organizationStudentsXlsxCreateMutation = {
  response: MATOrganizationTeachersXlsxCreateDialog_organizationStudentsXlsxCreateMutation$data;
  variables: MATOrganizationTeachersXlsxCreateDialog_organizationStudentsXlsxCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "organizationTeachersXlsxCreate",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MATOrganizationTeachersXlsxCreateDialog_organizationStudentsXlsxCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MATOrganizationTeachersXlsxCreateDialog_organizationStudentsXlsxCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f040a5e6ca37b0d49f8136d34c2762a5",
    "id": null,
    "metadata": {},
    "name": "MATOrganizationTeachersXlsxCreateDialog_organizationStudentsXlsxCreateMutation",
    "operationKind": "mutation",
    "text": "mutation MATOrganizationTeachersXlsxCreateDialog_organizationStudentsXlsxCreateMutation(\n  $input: OrganizationTeachersXlsxCreateInput!\n) {\n  organizationTeachersXlsxCreate(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "df51c3e2c70ce0c9264176c39d4c545e";

export default node;
